import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormDesignDto, CreateUpdateFormDesignDto } from '../api/data-model';
import { BACKEND_URL } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class FormDesignService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string
  ) { }

  // GET /api/app/form-design
  query(
    entityType: number,
    entityId: string,
    publishedOnly: boolean = false
  ): Observable<FormDesignDto> {
    return this.http.get<FormDesignDto>(`${this.baseUrl}/api/app/form-design`, {
      params: {
        entityType: entityType.toString(),
        entityId: entityId,
        publishedOnly: publishedOnly
      }
    });
  }

  // POST /api/app/form-design
  create(formDesign: CreateUpdateFormDesignDto): Observable<FormDesignDto> {
    return this.http.post<FormDesignDto>(`${this.baseUrl}/api/app/form-design`, formDesign);
  }

  // PUT /api/app/form-design/{id}
  update(id: string, formDesign: CreateUpdateFormDesignDto, forceUpdate: boolean = false): Observable<FormDesignDto> {
    return this.http.put<FormDesignDto>(`${this.baseUrl}/api/app/form-design/${id}`, formDesign, {
      params: {
        forceUpdate
      }
    });
  }

  // POST /api/app/form-design/{id}/publish
  publish(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/api/app/form-design/${id}/publish`, {});
  }

  // POST /api/app/form-design/{id}/abandon
  abandon(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/api/app/form-design/${id}/abandon`, {});
  }
}
